export default __webpack_public_path__ + "static/media/femimed_gabinet_2_thumbnail.9f2588be.webp";